module.exports = __webpack_public_path__ + "static/media/kalender_avacon.f459f52e.svg";